// Mui
import { styled } from "@mui/system";
import { Chip } from "@mui/material";

// Utils
import { shouldForwardProp } from "utils";
import { functionsPillColor } from "constants/constants";
import theme from "assets/styles/themes";

export type OptionsPillProps = {
    filterId: "function" | "hierarchy" | "team";
    type?: string;
    counter?: number;
    shouldShowFullLabels?: boolean;
    height?: number;
};

const getFunctionColor = (type: string | undefined) => {
    const listOfTypes = Object.keys(functionsPillColor);

    if (!type || !listOfTypes.includes(type.toLowerCase())) {
        return functionsPillColor["other"];
    }

    const newType = type.toLowerCase() as keyof typeof functionsPillColor;

    return functionsPillColor[newType];
};

const getFilterId = (filterId: string, type: string | undefined) => {
    if (filterId === "team") return theme.palette.primary.light;
    if (filterId === "hierarchy") return theme.palette.others.lightSkyBlue;
    if (filterId === "function") return getFunctionColor(type);
};

export const FilterOptionsPill = styled(Chip, {
    shouldForwardProp: (prop) =>
        shouldForwardProp<OptionsPillProps>(["filterId", "type", "counter", "height", "shouldShowFullLabels"], prop),
})<OptionsPillProps>(({ filterId, type, counter, shouldShowFullLabels = false, height = 28, theme }) => ({
    backgroundColor: getFilterId(filterId, type),
    height,
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
    "& .MuiChip-label": {
        maxWidth: !shouldShowFullLabels ? 160 : "fit-content",
        textOverflow: "ellipsis",
        whiteSpace: "pre",
        overflow: "hidden",
        fontSize: 12,
        color: type === "LEADERSHIP" ? theme.palette.text.alt : theme.palette.common.black,
        letterSpacing: "1.25px",
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
}));
